module.exports = __webpack_public_path__ + "assets/img/theX-content-11.77dc550c.png";